import { render, staticRenderFns } from "./IndustryTag.vue?vue&type=template&id=130a5ef2&scoped=true"
import script from "./IndustryTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustryTag.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./IndustryTag.vue?vue&type=style&index=0&id=130a5ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a5ef2",
  null
  
)

export default component.exports